import { createContext, useContext } from 'react';
export const MultiselectContext = createContext(undefined);
export const useMultiselect = () => {
    const context = useContext(MultiselectContext);
    if (context === undefined) {
        throw new Error('useMultiselect must be used within a MultiselectProvider');
    }
    return context;
};
//# sourceMappingURL=MultiselectContext.js.map